<template>
  <div class="p-input-wrap">
    <label
      class="p-input body-m-regular"
      :class="{
        error: entryError,
        big: desktopBig,
        'error-white': entryError && errorWhite,
      }"
    >
      <div class="slot-icon">
        <slot name="left" />
      </div>
      <input
        v-if="!mask"
        :name="name"
        class="custom-input body-m-regular"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        :type="type"
        autocomplete="off"
        :maxlength="maxLength"
        @focus="onFocus"
        @blur="onBlur"
        @keyup.enter="(e) => $emit('enter', e)"
        @input="onInput"
      />
      <input
        v-else
        ref="el"
        class="custom-input"
        :maxlength="maxLength"
        :value="value"
        :name="name"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        autocomplete="off"
        @focus="onFocus"
        @blur="onBlur"
        @keyup.enter="(e) => $emit('enter', e)"
      />
      <div class="slot-icon">
        <slot name="right" />
      </div>
    </label>
    <transition name="input-error">
      <div
        v-if="entryError"
        class="error-message"
        :class="{ white: errorWhite }"
      >
        {{ entryError }}
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { useIMask } from 'vue-imask';

export default defineComponent({
  name: 'PInput',
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    error: {
      type: String,
      default: '',
    },
    mask: {
      type: String,
      default: '',
    },
    masked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    desktopBig: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
    },
    errorWhite: Boolean,
    caretDisabledPosition: Number,
  },
  emits: ['focus', 'blur', 'enter', 'input', 'update:value'],
  setup(props, { emit }) {
    const focused = ref<boolean>(false);
    const { el } = useIMask(
      {
        mask: props.mask,
        radix: '.',
      },
      {
        onAccept: (e) => onInput(e),
      }
    );
    const entryError = computed(() => {
      if (props.error && !focused.value) return props.error;

      return null;
    });

    function onFocus(e: Event): void {
      focused.value = true;
      emit('focus', e);
    }

    function onBlur(e: Event): void {
      focused.value = false;
      emit('blur', e);
    }

    function onInput(e: Event | undefined): void {
      if (!e) return;
      // @ts-ignore
      emit('input', e.target.value);
      // @ts-ignore
      emit('update:value', e.target.value);
    }

    return {
      focused,
      entryError,
      onFocus,
      onBlur,
      onInput,
      el,
    };
  },
});
</script>

<style scoped lang="scss" src="./p-input-scss.scss" />
